// extracted by mini-css-extract-plugin
export default {"block":"CartFormPickupPoints_block__97tvw","text":"CartFormPickupPoints_text__MbMm0","warn":"CartFormPickupPoints_warn__+j6Ps"};